var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"feature-area"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('div',{class:['section-title', _vm.dark ? 'section-title-2' : '']},[_c('h1',{staticClass:"title center-text"},[_vm._v(_vm._s(_vm.$t('Trending_News')))])])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }